import { EditOutlined } from "@ant-design/icons";
import { Input, Modal, Form, Spin, Button, notification } from "antd";
import { Row, Col } from "reactstrap";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
// import { useHistory } from "react-router-dom";

// import ROUTE from "../../constants/routes";
import CancelAction from "../../Tools/CancelAction";
import { useAuth } from "../../context/auth";

const { TextArea } = Input;

const ActionModal = ({ visible, onCancel, onOk, editRecord }) => {
  const { accessToken } = useAuth();
  // const history = useHistory();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [hideNav, setHideNav] = useState(false);
  const [changed, setChange] = useState(false);
  const [openModalCancelAction, setOpenModalCancelAction] = useState(false);

  // const [buttonDisabled, setButtonDisabled] = useState(true);

  //const [listMember, setListMember] = useState([]);

  const save = async (values) => {
    const url = new URL('/api/contact-us', window.location);

    const res = await fetch(url, {
      headers: {
        'X-ACCESS-TOKEN': accessToken,
        'Content-type': 'application/json',
      },
      method: 'PATCH',
      body: JSON.stringify(values),
    });
    if (res.ok) {
      onOk();
      setLoading(false);
      Swal.fire({
        icon: "success",
        title: "Success !",
        text: "Successfully saved data.",
        showConfirmButton: false,
        timer: 1500,
      });
      form.resetFields();
    } else {
      notification["error"]({
        message: "Something went wrong !",
        description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
      });
    }
  };
  //console.log("test not01e", listMember);
  useEffect(() => {
    form.setFieldsValue({
      email: editRecord.email,
      phone: editRecord.phone,
      address: editRecord.address,
      facebook: editRecord.facebook,
      instagram: editRecord.instagram,
      line: editRecord.line,
    });
  });

  useEffect(() => {
    setHideNav(window.innerWidth <= 1000);
  }, []);

  //console.log("test note", editRecord);
  return (
    <>
      <Modal
        open={visible}
        title={
          <div className="flex items-center space-x-4">
            <EditOutlined />
            <span>Note</span>
          </div>
        }
        width={hideNav ? "95%" : "65%"}
        onCancel={() => {
          //setPaymentMethod("");
          if (changed) {
            setOpenModalCancelAction(true);
          } else {
            setOpenModalCancelAction(false);
            onCancel();
          }
        }}
        footer={
          <div className="w-full text-center mb-4 flex justify-center">
            <Button
              className="w-36"
              type="primary"
              ghost
              key="cancel"
              shape="round"
              onClick={() => {
                //setPaymentMethod("");
                if (changed) {
                  setOpenModalCancelAction(true);
                } else {
                  setOpenModalCancelAction(false);
                  onCancel();
                }
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                form.validateFields().then((values) => {
                  save(values);
                });
              }}
              className="w-36"
              key="save"
              type="primary"
              shape="round"
              loading={loading}
            >
              Save
            </Button>
          </div>
        }
      >
        <Spin spinning={loading} tip="Loading...">
          <Form
            onFieldsChange={(_, allFields) => {
              if (allFields.length > 0) {
                setChange(true);
              }
            }}
            form={form}
            name="charger-management"
            className="price"
            layout="vertical"
          >
            <Row>
              <Col lg="6">
                <Form.Item
                  label="Email Support"
                  colon={false}
                  name="email"
                  rules={[
                    {
                      required: editRecord && !editRecord.email,
                      message: "Email Support is required.",
                    },
                    {
                      message: "Email Support is not whitespace",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input
                    // disabled={editRecord && editRecord.id}
                    placeholder="Email"
                    maxLength={20}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col lg="6">
                <Form.Item
                  label="Call Center"
                  colon={false}
                  name="phone"
                  rules={[
                    {
                      required: editRecord && !editRecord.email,
                      message: "Call Center is required.",
                    },
                    {
                      message: "Call Center is not whitespace",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input placeholder="Call Center" maxLength={50} allowClear />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col lg="6">
                <Form.Item label="Facebook" colon={false} name="facebook">
                  <Input placeholder="Facebook" maxLength={50} allowClear />
                </Form.Item>
              </Col>
              <Col lg="6">
                <Form.Item label="Instagram" colon={false} name="instagram">
                  <Input placeholder="Instagram" maxLength={50} allowClear />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <Form.Item
                  label="LINE"
                  colon={false}
                  name="line"
                  rules={[
                    {
                      required: true,
                      message: "LINE is required.",
                    },
                  ]}
                >
                  <Input placeholder="LINE" maxLength={50} allowClear />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col lg="12">
                <Form.Item label="Address " colon={false} name="address">
                  <TextArea
                    placeholder="Address"
                    maxLength={255}
                    allowClear
                    style={{ height: 80 }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col lg="6">
                <Form.Item
                  label="Min Version (Android)"
                  colon={false}
                  name="minVersionAndroid"
                >
                  <Input placeholder="Min Version (Android)" maxLength={255} allowClear />
                </Form.Item>
              </Col>
              <Col lg="6">
                <Form.Item
                  label="Min Version (iOS)"
                  colon={false}
                  name="minVersionIOS"
                >
                  <Input placeholder="Min Version (iOS)" maxLength={255} allowClear />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Modal>

      <CancelAction
        openModalCancelAction={openModalCancelAction}
        onOk={() => {
          setChange(false);
          onCancel();
        }}
        onCancel={() => {
          setOpenModalCancelAction(false);
        }}
      />
    </>
  );
};

export default ActionModal;
